module.exports = __webpack_public_path__ + "static/media/01-01.78a2cd24.mp3";